/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';
import {
    type PageTerminalDto,
    PageTerminalDtoFromJSON,
    PageTerminalDtoToJSON,
} from '../models/PageTerminalDto';
import {
    type PageTerminalEventDto,
    PageTerminalEventDtoFromJSON,
    PageTerminalEventDtoToJSON,
} from '../models/PageTerminalEventDto';
import {
    type TerminalDto,
    TerminalDtoFromJSON,
    TerminalDtoToJSON,
} from '../models/TerminalDto';

export interface GetTerminalRequest {
    externalId: string;
}

export interface SearchTerminalEventsRequest {
    externalId: string;
    pageNo?: number;
    pageSize?: number;
    sortBy?: string;
    direction?: SearchTerminalEventsDirectionEnum;
}

export interface SearchTerminalsRequest {
    searchParam?: string;
    query?: string;
    pageNo?: number;
    pageSize?: number;
    sortBy?: string;
    direction?: SearchTerminalsDirectionEnum;
}

/**
 * 
 */
export class TerminalControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for getTerminal without sending the request
     */
    async getTerminalRequestOpts(requestParameters: GetTerminalRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['externalId'] == null) {
            throw new runtime.RequiredError(
                'externalId',
                'Required parameter "externalId" was null or undefined when calling getTerminal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/terminals/{externalId}`;
        urlPath = urlPath.replace('{externalId}', encodeURIComponent(String(requestParameters['externalId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getTerminalRaw(requestParameters: GetTerminalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TerminalDto>> {
        const requestOptions = await this.getTerminalRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerminalDtoFromJSON(jsonValue));
    }

    /**
     */
    async getTerminal(requestParameters: GetTerminalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TerminalDto> {
        const response = await this.getTerminalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchTerminalEvents without sending the request
     */
    async searchTerminalEventsRequestOpts(requestParameters: SearchTerminalEventsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['externalId'] == null) {
            throw new runtime.RequiredError(
                'externalId',
                'Required parameter "externalId" was null or undefined when calling searchTerminalEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/terminals/{externalId}/events/search`;
        urlPath = urlPath.replace('{externalId}', encodeURIComponent(String(requestParameters['externalId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async searchTerminalEventsRaw(requestParameters: SearchTerminalEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageTerminalEventDto>> {
        const requestOptions = await this.searchTerminalEventsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageTerminalEventDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchTerminalEvents(requestParameters: SearchTerminalEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageTerminalEventDto> {
        const response = await this.searchTerminalEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for searchTerminals without sending the request
     */
    async searchTerminalsRequestOpts(requestParameters: SearchTerminalsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['searchParam'] != null) {
            queryParameters['searchParam'] = requestParameters['searchParam'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['pageNo'] != null) {
            queryParameters['pageNo'] = requestParameters['pageNo'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['direction'] != null) {
            queryParameters['direction'] = requestParameters['direction'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/terminals/search`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async searchTerminalsRaw(requestParameters: SearchTerminalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageTerminalDto>> {
        const requestOptions = await this.searchTerminalsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageTerminalDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchTerminals(requestParameters: SearchTerminalsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageTerminalDto> {
        const response = await this.searchTerminalsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const SearchTerminalEventsDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type SearchTerminalEventsDirectionEnum = typeof SearchTerminalEventsDirectionEnum[keyof typeof SearchTerminalEventsDirectionEnum];
/**
 * @export
 */
export const SearchTerminalsDirectionEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type SearchTerminalsDirectionEnum = typeof SearchTerminalsDirectionEnum[keyof typeof SearchTerminalsDirectionEnum];
